import React from 'react'

import {
  getSourceDescription
} from '../../../utils'

import {
  Grid, Accordion, AccordionSummary, AccordionDetails,
  Typography, List, ListItem, Button, Divider
} from '@material-ui/core'

import {
  Info as InfoIcon
} from '@material-ui/icons'

import MenuButton from './MenuButton'

import log from 'loglevel'

export const DetailsAccordion = ({
  accordionExpanded, classes, handleAccordionChange, capture,
  handleQuickFilter, violationAdditionalTerms, sessionCapture,
  ipAddress
}) => {
  const renderUnit = (capture) => {
    const arr = capture.units.map((unit) => unit.unitName)
    return arr.join('/ ')
  }

  return (
    <>
      <Grid item container direction='row' className='w-100 mx-auto'>
        <Accordion
          expanded={accordionExpanded === 'details'}
          onChange={handleAccordionChange('details')}
          className={`w-100 ${classes.contentAccordion}`}
        >
          <AccordionSummary
            expandIcon={<MenuButton margin='auto' open={accordionExpanded === 'details'} />}
          >
            <Grid container direction='row' item xs={10} spacing={2} className='w-100' justify='space-around' alignItems='center'>
              <Grid item xs={4}>
                <Typography variant='h6' className='font-weight-bold text-primary'><InfoIcon fontSize='large' /> DETAILS</Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography className='text-muted'>Capture ID: {capture.violationID}</Typography>
              </Grid>
            </Grid>
          </AccordionSummary>

          <AccordionDetails className={classes.accordionDetails}>
            <List className='w-100' dense>
              <ListItem>
                <Grid container direction='row' justify='center' className='w-100 mx-auto'>
                  <Grid item container direction='column' xs={4} justify='center'>
                    <Grid item container direction='row' justify='center'>
                      <Typography className=''>User:</Typography>
                    </Grid>
                    <Grid item container direction='row' justify='center'>
                      {
                        capture.username
                          ? (
                            <Button
                              variant='text'
                              fullWidth
                              color='primary'
                              className='font-weight-bold text-break'
                              size='small'
                              onClick={() => handleQuickFilter({ username: capture.username })}
                            >
                              {capture.username}
                            </Button>
                          ) : (
                            <Typography>N/A</Typography>
                          )
                      }
                      {/* {toggleUsername(handleQuickFilter, capture)} */}
                    </Grid>
                  </Grid>

                  {
                    capture.multiple_phrases
                      ? (
                        <Grid item container direction='column' xs={4} justify='center'>
                          <Grid item container direction='row' justify='center'>
                            <Typography className=''>All Terms Found:</Typography>
                          </Grid>
                          <Grid item container direction='row' justify='center'>
                            {
                              violationAdditionalTerms.length
                                ? violationAdditionalTerms.map((addtlPhrase, idx) => (
                                  <Button
                                    key={`addtlphrase${idx}`}
                                    variant='text'
                                    fullWidth
                                    color='primary'
                                    className='font-weight-bold'
                                    size='small'
                                    style={{ cursor: 'auto' }}
                                    onClick={() => log.debug(idx)}
                                  >
                                    {addtlPhrase.phrase} - {addtlPhrase.severity}
                                  </Button>
                                )) : (
                                  <Typography>None</Typography>
                                )
                            }
                            {/* {togglePhrase(handleQuickFilter, capture)} */}
                          </Grid>
                        </Grid>
                      ) : (
                        <Grid item container direction='column' xs={4} justify='center'>
                          <Grid item container direction='row' justify='center'>
                            <Typography className=''>Word/Phrase:</Typography>
                          </Grid>
                          <Grid item container direction='row' justify='center'>
                            {
                              capture.phrase
                                ? (
                                  <Button
                                    variant='text'
                                    fullWidth
                                    color='primary'
                                    className='font-weight-bold'
                                    size='small'
                                    onClick={() => handleQuickFilter({ phrase: capture.phrase })}
                                  >
                                    {capture.phrase}
                                  </Button>
                                ) : (
                                  <Typography>N/A</Typography>
                                )
                            }
                            {/* {togglePhrase(handleQuickFilter, capture)} */}
                          </Grid>
                        </Grid>
                      )
                  }

                  <Grid item container direction='column' xs={4} justify='center'>
                    <Grid item container direction='row' justify='center'>
                      <Typography className=''>Station:</Typography>
                    </Grid>
                    <Grid item container direction='row' justify='center'>
                      {
                        capture.workstationName
                          ? (
                            <Button
                              variant='text'
                              fullWidth
                              color='primary'
                              className='font-weight-bold'
                              size='small'
                              onClick={() => handleQuickFilter({ workstationName: capture.workstationName })}
                            >
                              {capture.workstationName}
                            </Button>
                          ) : (
                            <Typography>N/A</Typography>
                          )
                      }
                      {/* {toggleWorkstationName(handleQuickFilter, capture)} */}
                    </Grid>
                  </Grid>
                </Grid>
              </ListItem>

              <Divider variant='middle' />

              <ListItem>
                <Grid container direction='row' justify='center' spacing={2} className='w-100 mx-auto'>
                  <Grid item container direction='column' xs={4} justify='center'>
                    <Grid item container direction='row' justify='center'>
                      <Typography className=''>Source:</Typography>
                    </Grid>
                    <Grid item container direction='row' justify='center'>
                      {
                        getSourceDescription(capture.source)
                          ? (
                            <Button
                              variant='text'
                              fullWidth
                              color='primary'
                              className='font-weight-bold'
                              size='small'
                              onClick={() => handleQuickFilter({ source: capture.source })}
                            >
                              {getSourceDescription(capture.source)}
                            </Button>
                          ) : (
                            <Typography>N/A</Typography>
                          )
                      }
                      {/* {toggleSource(handleQuickFilter, capture)} */}
                    </Grid>
                  </Grid>

                  <Grid item container direction='column' xs={4} justify='center'>
                    <Grid item container direction='row' justify='center'>
                      <Typography className=''>Application:</Typography>
                    </Grid>
                    <Grid item container direction='row' justify='center'>
                      {
                        capture.applicationName
                          ? (
                            <Button
                              variant='text'
                              fullWidth
                              color='primary'
                              className='font-weight-bold'
                              size='small'
                              onClick={() => handleQuickFilter({ applicationName: capture.applicationName })}
                            >
                              {capture.applicationName}
                            </Button>
                          ) : (
                            <Typography>N/A</Typography>
                          )
                      }
                      {/* {toggleApplicationName(handleQuickFilter, capture)} */}
                    </Grid>
                  </Grid>

                  <Grid item container direction='column' xs={4} justify='center'>
                    <Grid item container direction='row' justify='center'>
                      <Typography className=''>Category:</Typography>
                    </Grid>
                    <Grid item container direction='row' justify='center'>
                      {
                        capture.categoryName
                          ? (
                            <Button
                              variant='text'
                              fullWidth
                              color='primary'
                              className='font-weight-bold'
                              size='small'
                              onClick={() => handleQuickFilter({ categoryName: capture.categoryName })}
                            >
                              {capture.categoryName}
                            </Button>
                          ) : (
                            <Typography>N/A</Typography>
                          )
                      }
                      {/* {toggleCategoryName(handleQuickFilter, capture)} */}
                    </Grid>
                  </Grid>
                </Grid>
              </ListItem>

              <Divider variant='middle' />

              <ListItem>
                <Grid container direction='row' justify='center' spacing={2} className='w-100 mx-auto'>
                  <Grid item container direction='column' xs={4} justify='center'>
                    <Grid item container direction='row' justify='center'>
                      <Typography className=''>Session Captures:</Typography>
                    </Grid>
                    <Grid item container direction='row' justify='center'>
                      {sessionCapture}
                    </Grid>
                  </Grid>

                  <Grid item container direction='column' xs={4} justify='center'>
                    <Grid item container direction='row' justify='center'>
                      <Typography className=''>IP Addr:</Typography>
                    </Grid>
                    <Grid item container direction='row' justify='center'>
                      {ipAddress}
                    </Grid>
                  </Grid>

                  {/* Note by CC: LS requested removal of location link on 10/14/2021 */}
                  <Grid item container direction='column' xs={4} justify='center'>
                    <Grid item container direction='row' justify='center'>
                      <Typography className=''>Location:</Typography>
                    </Grid>
                    <Grid item container direction='row' justify='center'>
                      {renderUnit(capture)}
                    </Grid>
                  </Grid>
                </Grid>
              </ListItem>
            </List>
          </AccordionDetails>
        </Accordion>
      </Grid>
    </>
  )
}

export default DetailsAccordion
